import { unwrapResponse } from './unwrapResponse.js';
import { ApiResponse } from '../../../server/types.js';

interface FetchOptions extends RequestInit {
  token: string;
}

export async function fetchWithAuth<T = any>(url: string, options: FetchOptions): Promise<T> {
  try {
    console.log(`Fetching ${url}...`);
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${options.token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText,
        error: errorText
      });
      throw new Error(`API request failed: ${errorText}`);
    }

    // Handle empty responses (204 No Content or empty body)
    if (response.status === 204 || response.headers.get('content-length') === '0') {
      return undefined as T;
    }

    const data = await response.json() as ApiResponse<T>;
    console.log(`Response from ${url}:`, data);
    return unwrapResponse(data);
  } catch (error) {
    console.error('fetchWithAuth error:', error);
    throw error;
  }
}
